import type { DadosAreaConstruida } from '@/features/laudo/types/laudo-wizard.types';
export function getValorUnitarioConstrucaoAvaliando(
  dadosAreaConstruida: DadosAreaConstruida[] | undefined,
): number {
  const avaliando = dadosAreaConstruida?.find((d) => d.identificacao === 'Avaliando');
  if (!avaliando) return 0;
  if (avaliando.cubAjustado && avaliando.cubAjustado > 0) return avaliando.cubAjustado;
  const cubBase = avaliando.cubBase || 2500;
  const ajuste = avaliando.ajusteAcabamento || 1;
  const depreciacao = avaliando.depreciacao || 0;
  return cubBase * ajuste * (1 - depreciacao);
}
